
import { useParams, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import CashView from "./update-assets/CashView";
import PropertyView from "./update-assets/PropertyView";
import VehicleView from "./update-assets/VehicleView";
import InsuranceView from "./update-assets/InsuranceView";
import BankAccountView from "./update-assets/BankAccountView";
import MutualFundView from "./update-assets/MutualFundView";
import FixedDepositView from "./update-assets/FixedDepositView";
import StockView from "./update-assets/StockView";
import CryptoView from "./update-assets/CryptoView";
import ImportantPapersView from "./update-assets/ImportantPapersView";
import CollectiblesView from "./update-assets/CollectiblesView";
import PreciousMetalsView from "./update-assets/PreciousMetalsView";
import OtherPhysicalAssetsView from "./update-assets/OtherPhysicalAssetsView";
import BusinessOwnershipView from "./update-assets/BusinessOwnershipView";
import { api, getAuthHeaders } from "../utils/api";
import Loader from "../components/Loader";
const AssetDetails = () => {
  const { assetId } = useParams();
  const location = useLocation();
  const shouldStartInEditMode = location.state?.edit || false;
  const [assetType, setAssetType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssetType = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get(`/assets/${assetId}`, { headers: getAuthHeaders() });
        setAssetType(response.data.assetType || "cash");
      } catch (e) {
        setError(e?.message || "Failed to fetch asset type");
      } finally {
        setLoading(false);
      }
    };
    if (assetId) fetchAssetType();
  }, [assetId]);

  let ViewComponent = null;
  if (assetType === "cash") ViewComponent = CashView;
  else if (assetType === "homeProperty" || assetType === "property") ViewComponent = PropertyView;
  else if (assetType === "vehicles") ViewComponent = VehicleView;
  else if (assetType === "insurance") ViewComponent = InsuranceView;
  else if (assetType === "bankAccounts") ViewComponent = BankAccountView;
  else if (assetType === "mutualFunds") ViewComponent = MutualFundView;
  else if (assetType === "fixedDeposits") ViewComponent = FixedDepositView;
  else if (assetType === "stocks") ViewComponent = StockView;
  else if (assetType === "crypto") ViewComponent = CryptoView;
  else if (assetType === "importantPapers" || assetType === "important papers") ViewComponent = ImportantPapersView;
  else if (assetType === "collectibles") ViewComponent = CollectiblesView;
    else if (assetType === "preciousMetals" || assetType === "precious metals") ViewComponent = PreciousMetalsView;
  else if (assetType === "otherPhysicalAssets" || assetType === "other physical assets") ViewComponent = OtherPhysicalAssetsView;
    else if (assetType === "businessOwnership" || assetType === "business ownership") ViewComponent = BusinessOwnershipView;
  // Add more asset types here as needed

  return (
    <Layout>
      {loading ? (
        <div><Loader /></div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : ViewComponent ? (
        <ViewComponent assetId={assetId} startInEditMode={shouldStartInEditMode} />
      ) : (
        <div></div>
      )}
    </Layout>
  );
};

export default AssetDetails;
